// Langue proposée pour une invitation depuis une fiche (04/11/2026, décision de Maxime) : le français là où l'on parle
// français (pays de la fiche, et région pour la Suisse, le Canada et la Belgique), l'anglais partout ailleurs et quand
// on ne sait rien. Celui qui invite peut la changer ; le compte la garde.
import type { AccountLocale } from "./accountLocale";

// France et outre-mer, Monaco, Luxembourg, Afrique et océan Indien francophones, Maghreb, Haïti.
const FRENCH_COUNTRIES = new Set([
  "FR",
  "GP",
  "MQ",
  "GF",
  "RE",
  "YT",
  "PM",
  "BL",
  "MF",
  "NC",
  "PF",
  "WF",
  "MC",
  "LU",
  "SN",
  "CI",
  "CM",
  "CD",
  "CG",
  "GA",
  "ML",
  "BF",
  "NE",
  "TD",
  "GN",
  "BJ",
  "TG",
  "MG",
  "CF",
  "BI",
  "DJ",
  "KM",
  "MU",
  "SC",
  "MA",
  "DZ",
  "TN",
  "MR",
  "HT",
]);

const fold = (text: string) =>
  text.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();

const words = (region: string) =>
  fold(region)
    .split(/[^a-z]+/)
    .filter(Boolean);

// Cantons romands (Valais sous son nom français : « Oberwallis » est le Haut-Valais germanophone).
const ROMANDE = new Set([
  "vaud",
  "vd",
  "geneve",
  "geneva",
  "ge",
  "neuchatel",
  "ne",
  "jura",
  "ju",
  "fribourg",
  "fr",
  "valais",
  "vs",
]);

// Québec et ses régions administratives telles que les sources les écrivent.
const QUEBEC = [
  "quebec",
  "qc",
  "capitale nationale",
  "mauricie",
  "saguenay",
  "cote nord",
  "chaudiere",
  "outaouais",
  "laurentides",
  "montreal",
  "laval",
  "lanaudiere",
  "monteregie",
  "estrie",
  "gaspesie",
  "abitibi",
  "bas saint laurent",
];

const FLANDERS = [
  "flanders",
  "vlaanderen",
  "flemish",
  "antwerp",
  "limburg",
  "vlaams",
];

export const inviteLocaleFor = (
  country: string | null | undefined,
  region?: string | null,
): AccountLocale => {
  const code = (country ?? "").toUpperCase();
  const place = region ?? "";
  if (FRENCH_COUNTRIES.has(code)) return "fr";
  if (code === "CH")
    return words(place).some((w) => ROMANDE.has(w)) ? "fr" : "en";
  if (code === "CA") {
    const text = words(place).join(" ");
    return QUEBEC.some((name) => text.includes(name)) ? "fr" : "en";
  }
  if (code === "BE") {
    const text = fold(place);
    return FLANDERS.some((name) => text.includes(name)) ? "en" : "fr";
  }
  return "en";
};
